import {useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {Toolbar} from './components/toolbar/Toolbar'
import {RightToolbar} from '../partials/layout/RightToolbar'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {ActivityDrawer, DrawerMessenger, InviteUsers, UpgradePlan} from '../partials'
import {MenuComponent} from '../assets/ts/components'
import {HomeHeader} from '../../app/pages/home/fr/component/HomeHeader'
import {GeHomeHeader} from '../../app/pages/home/ge/component/GeHomeHeader'
import { checkIsActive } from '../helpers'

const MasterLayout = () => {
  const location = useLocation()

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])
const {pathname} = useLocation()
  return (
    <PageDataProvider>
      <div className='d-flex flex-column flex-root container-fluid'>
        <div>{checkIsActive(pathname, 'fr') ? <HomeHeader /> : <GeHomeHeader />}</div>
        {/* <HeaderWrapper /> */}
        {/* begin::Page */}

        {/* begin::Wrapper */}

        {/* begin::Content */}
        <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
          <Outlet />
        </div>
        {/* end::Content */}

        {/* end::Wrapper */}

        {/* end::Page */}
      </div>
      <Footer />

      {/* end:: Modals */}
      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
